// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountMenuComponentController from "./account_menu_component_controller"
application.register("account-menu-component", AccountMenuComponentController)

import DashboardPanelComponentController from "./dashboard_panel_component_controller"
application.register("dashboard-panel-component", DashboardPanelComponentController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import HelpCenterController from "./help_center_controller"
application.register("help-center", HelpCenterController)

import InterviewController from "./interview_controller"
application.register("interview", InterviewController)

import JsController from "./js_controller"
application.register("js", JsController)

import MessengerMessageReadController from "./messenger_message_read_controller"
application.register("messenger-message-read", MessengerMessageReadController)

import MultiSelectEventController from "./multi_select_event_controller"
application.register("multi-select-event", MultiSelectEventController)

import PopperController from "./popper_controller"
application.register("popper", PopperController)
